<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.user_name" placeholder="用户名" style="width:200px" />
      <el-input v-model="query.id_card" placeholder="身份证" style="width:200px" />
      <el-input v-model="query.nc_id" placeholder="用友编号" style="width:200px" />
      <el-select placeholder="用友状态" v-model="query.status">
        <el-option label="禁用" value="0"></el-option>
        <el-option label="未申请" value="1"></el-option>
        <el-option label="已申请" value="2"></el-option>
      </el-select>
      <el-button type="primary" @click="getList">搜索</el-button>
    </div>

<!--
CREATE TABLE `sp_employee_nc` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `master_user_id` int(11) DEFAULT NULL COMMENT '用户ID',
  `user_name` varchar(50) DEFAULT NULL COMMENT '姓名',
  `id_card` varchar(20) DEFAULT NULL COMMENT '身份证',
  `nc_id` varchar(50) DEFAULT NULL COMMENT 'nc的ID',
  `nc_name` varchar(50) DEFAULT NULL COMMENT 'nc的名称',
  `status` tinyint(1) DEFAULT '1' COMMENT '状态：0禁用，1未有，2,已申请',
  `create_time` datetime DEFAULT NULL COMMENT '创建时间',
  `update_time` datetime DEFAULT NULL COMMENT '修改时间',
  PRIMARY KEY (`id`),
  KEY `master_user_id` (`master_user_id`),
  KEY `nc_id` (`nc_id`),
  KEY `nc_name` (`nc_name`),
  KEY `user_name` (`user_name`),
  KEY `id_card` (`id_card`)
) ENGINE=InnoDB AUTO_INCREMENT=132017 DEFAULT CHARSET=utf8 COMMENT='员工信息NC对照表';
-->

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="user_name" label="用户名" />
      <el-table-column prop="id_card" label="身份证" />
      <el-table-column prop="nc_id" label="用友ID" />
      <el-table-column prop="nc_name" label="用友用户名" />
      <el-table-column prop="status" label="状态" >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status===0">禁用</el-tag>
          <el-tag v-if="scope.row.status===1">未申请</el-tag>
          <el-tag v-if="scope.row.status===2">已申请</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" />
      <el-table-column prop="update_time" label="创建时间" />
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="scope.row.status===1" @click="addYY(scope.row)">添加到用友</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="pageChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next"
      :total="pageData.total"
      style="margin-top:15px;text-align:right"
    />
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'EmployeeNc',
  data() {
    return {
      query: {
        user_name:"",
        id_card:"",
        nc_id:"",
        status:""
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.user_name ? ['user_name', 'like', `%${this.query.user_name}%`] : null)
        .where(this.query.id_card ? ['id_card', '=', this.query.id_card] : null)
        .where(this.query.nc_id ? ['nc_id', '=', this.query.nc_id] : null)
        .where(this.query.status ? ['status', '=', this.query.status] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('EmployeeNc/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {}
      this.dialogVisible = true
    },

    addYY(row) {
      const that = this;
      that.$confirm('确定添加到用友？').then(async () => {
        // that.$message.success('将发起流程')
        Http.post('EmployeeNc/addYY', {id:row.id}, res => {
          if(res.code===200){
            that.$message.success('操作成功')
            that.getList()
          }else {
            that.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })
      })
    },

    // 编辑
    // async handleEdit(id) {
    //   const res = await api.detail(Params.ins().detail(id))
    //   if (res.code === 200) {
    //     this.form = res.data
    //     this.dialogVisible = true
    //   }
    // },
    //
    // // 提交保存
    // async submit() {
    //   const res = await api.save(Params.ins().save(this.form))
    //   if (res.code === 200) {
    //     this.$message.success('操作成功')
    //     this.dialogVisible = false
    //     this.getList()
    //   }
    // },
    //
    // // 删除
    // async handleDelete(id) {
    //   this.$confirm('确定删除？').then(async () => {
    //     const res = await api.delete(Params.ins().delete(id))
    //     if (res.code === 200) {
    //       this.$message.success('删除成功')
    //       this.getList()
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/FinancialCenter/EmployeeNc.vue